import css from "styled-jsx/css";

export const componentStyles = css`
  .slim-footer-component {
    margin: auto;
  }
`;
